import { TourTranslationsList } from '@/components/tours/translations';
import { useParams } from 'react-router-dom';

export function TourTranslationsTab() {
  const { id } = useParams<{ id: string }>();

  if (!id) return null;

  return <TourTranslationsList tourId={id} className="p-0" />;
}
